"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _keyframes = require("./keyframes");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    animation: ", " 1.4s ease-in-out 0s infinite;\n    stroke: ", ";\n    stroke-dasharray: 80px, 200px;\n    stroke-dashoffset: 0;\n    stroke-linecap: round;\n    transform: translateZ(0);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Circle = _styledComponents["default"].circle(_templateObject(), _keyframes.containerRotate, function (props) {
  return props.theme.circleColor;
});

var _default = Circle;
exports["default"] = _default;